





















import Vue from 'vue'

export const VERSION_CHECKER_BUILD_URL = '/build.json'
export const VERSION_CHECKER_LAST_LS_KEY = 'last_version'
export const VERSION_CHECKER_CURRENT_LS_KEY = 'current_version'

const VER_REGEXP = /^(\d+\.)?(\d+\.)?(\*|\d+)$/
export default Vue.extend({
  props: {
    PFX: {
      type: String,
      default: '_',
      required: true
    },
    bundleVersion: {
      type: String,
      required: true
    },
    watchInterval: {
      type: Number,
      default: 120000
    }
  },
  data () {
    return {
      showErr: false,
      showSuccess: false,
      interval: null
    }
  },
  methods: {
    reload (): void {
      document.location.reload(true)
    },
    async loadBuildInfo (): Promise<string | undefined> {
      let response = await fetch(VERSION_CHECKER_BUILD_URL + '?' + Date.now())
      let build: {version: string} = await response.json()
      return build.version
    },
    async checkVersion (): Promise<void> {
      try {
        let ver = await this.loadBuildInfo()
        if (ver && VER_REGEXP.test(ver)) {
          localStorage.setItem(this.PFX + VERSION_CHECKER_CURRENT_LS_KEY, ver)
          if (ver !== this.bundleVersion) {
            this.showErr = true
          }
        } else {
          throw new Error(`Unexpected version! ${ver}`)
        }
      } catch (error) {
        console.error('load build info error', error)
        throw error
      }
    },
    checkNewVersionLoad () {
      let current = localStorage.getItem(this.PFX + VERSION_CHECKER_CURRENT_LS_KEY)
      let last = localStorage.getItem(this.PFX + VERSION_CHECKER_LAST_LS_KEY)
      if (last && current! > last) {
        this.$message(
          {
            type: 'success',
            duration: 5000,
            // @ts-ignore
            message: this.$t('labels.system_updated_success'),
            customClass: 'version-checker-message'
          }
        )
        //   this.showSuccess = true
      }
      this.setLastVersion(current!)
    },
    setLastVersion (ver: string) {
      localStorage.setItem(this.PFX + VERSION_CHECKER_LAST_LS_KEY, ver)
    },
    close () {
      this.showErr = false
      this.showSuccess = false
    },
    versionWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        // @ts-ignore
        self.checkVersion();
      }, this.watchInterval)
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    },
    onWindowFocus (): void {
      if (!this.interval) {
        this.versionWatcher()
      }
    }
  },
  async mounted () {
    await this.checkVersion()
    this.versionWatcher()
    this.checkNewVersionLoad()
    this.$root.$on('on-window-focus', this.onWindowFocus)
  },
  beforeDestroy () {
    // @ts-ignore
    clearInterval(this.interval)
    this.clearInterval()
    this.$root.$off('on-window-focus', this.onWindowFocus)
  }
})
